import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Button } from 'antd';
import {
  DownloadOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  HistoryOutlined,
} from '@ant-design/icons';
import {
  CustomButton,
  CustomTable,
  CustomTabs,
  CustomText,
} from '../../../../components';
import GestorTableItems from '../components/ByRoles/GestorTableItems';

interface GoodsDetailViewProps {
  detailData?: any;
  onDocuments: (id: string) => void;
  onDownloadPDF: (id: string) => void;
  setFooterLeft: (footer: React.ReactNode) => void;
}

const GoodsDetailView: React.FC<GoodsDetailViewProps> = ({
  detailData,
  onDocuments,
  onDownloadPDF,
  setFooterLeft,
}) => {
  const [columTableBienes, setColumTableBienes] = useState<any>([]);
  const [columTableFijos, setColumTableFijos] = useState<any>([]);

    // FOOTER
  React.useEffect(() => {
    setFooterLeft(
      <>
      <CustomButton
        label="Descargar documentos"
        disabled={!detailData?.documents && detailData?.documents?.length === 0}
        onClick={() => {
          onDocuments(detailData?.id || '');
        }}
        icon={<DownloadOutlined />}
        size="middle"
        buttonType="secondary"
      />

      <CustomButton
        style={{ marginLeft: '20px' }}
        label="Generar comprobante"
        disabled={detailData?.status_id !== 7}
        onClick={() => {
          onDownloadPDF(detailData?.id_petition || '');
        }}
        icon={<DownloadOutlined />}
        size="middle"
        buttonType="secondary"
      />
      </>
    );
  }, [detailData, setFooterLeft]);

  useEffect(() => {
    const validate = ([12, 14, 7] as number[]).includes(detailData?.status_id);
    setColumTableBienes([
      {
        title: 'Item',
        dataIndex: 'index',
        key: 'index',
        align: 'center',
        render: (_: any, __: any, index: number) => index + 1,
      },
      {
        title: 'Código de producto',
        dataIndex: 'product_code',
        key: 'product_code',
        align: 'center',
        render: (data: any) => data ? data : "-"
      },
      {
        title: 'Descripción',
        dataIndex: 'description',
        key: 'description',
        align: 'center',
        render: (data: any) => data ? data : "-"
      },
      {
        title: 'Grupo de bienes',
        dataIndex: 'good_class',
        key: 'good_class',
        align: 'center',
        render: (data: any) => data ? data.group_code + ' - ' + data.name : "-"
      },
      {
        title: 'Unidad de medida',
        dataIndex: 'unit_measurement',
        key: 'unit_measurement',
        align: 'center',
        render: (data: any) => data ? data.name : "-"
      },
      {
        title: 'Cantidad solicitada',
        dataIndex: 'quantity_requested',
        key: 'quantity_requested',
        align: 'center',
        render: (data: any) => data ? data : "-"
      },
      {
        title: 'Cantidad entregada',
        dataIndex: 'quantity_received',
        key: 'quantity_received',
        align: 'center',
        render: (data: any) => data ? data : "-"
      },
      {
        title: 'Estado por elemento',
        dataIndex: 'status',
        key: 'status',
      },
    ],)
    setColumTableFijos([
      {
        title: 'Item',
        dataIndex: 'index',
        key: 'index',
        render: (_: any, __: any, index: number) => index + 1,
      },
      {
        title: 'Código / placa',
        dataIndex: 'article',
        hidden: (!validate),
        key: 'article',
        render: (_: any, record: any) => record.plate_code,
      },
      {
        title: 'Descripción',
        dataIndex: 'description',
        hidden: (!validate),
        key: 'description',
      },
      {
        title: 'Costo histórico',
        dataIndex: 'historical_cost',
        hidden: (!validate),
        key: 'historical_cost',
        render: (value: number) => 
          value !== null && value !== undefined
            ? new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(value)
            : '-',
      },
      {
        title: 'Nueva ubicación',
        dataIndex: 'location',
        hidden: (!validate),
        key: 'location',
      },
      {
        title: 'Artículo',
        dataIndex: 'article',
        key: 'article',
        hidden: validate,
        render: (_: any, record: any) => record.item?.code + ' - ' + record.item?.name,
      },
      {
        title: 'Clase de activos',
        dataIndex: 'asset_class',
        key: 'aset_class',
        hidden: validate,
        render: (_: any, record: any) => record.item?.asset_class?.code + ' - ' + record.item?.asset_class?.name,
      },
      {
        title: 'Estado por elemento',
        dataIndex: 'status',
        key: 'status',
      },
    ],)
  }, [detailData]);

  const documentColumns = [
    {
      title: 'Item',
      dataIndex: 'index',
      key: 'index',
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
  ];

  return (
    <>
      <CustomTabs
        defaultActiveKey="1"
        items={[
          {
            key: '1',
            label: (
              <Button type="link" icon={<FileTextOutlined />}>
                Información de solicitud
              </Button>
            ),
            children: (
              <Fragment>
                <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText text="Número de ticket:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.ticket}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText text="Número transacción:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.transaction_code ? detailData?.transaction_code + detailData?.id_petition : "Sin registrar"}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText text="Código transacción:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.transaction_code ? detailData?.transaction_code : "Sin registrar"}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText text="Número de documento:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.document_requester}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText text="Tipo de movimiento:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.ticket_type}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText text="Fecha de transacción:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.transaction_date ? detailData?.transaction_date : "Sin registrar"}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Solicitante:"
                        strong
                        fontSize="small"
                      />
                      <CustomText
                        text={detailData?.requester}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Tipo de solicitud:"
                        strong
                        fontSize="small"
                      />
                      <CustomText text={detailData?.goods_type} fontSize="middle" />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Dependecia:"
                        strong
                        fontSize="small"
                      />
                      <CustomText text={detailData?.dependency} fontSize="middle" />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Ubicación:"
                        strong
                        fontSize="small"
                      />
                      <CustomText text={detailData?.location} fontSize="middle" />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Jefe de dependencia:"
                        strong
                        fontSize="small"
                      />
                      <CustomText
                        text={detailData?.approved_by ? detailData?.approved_by : 'Sin registrar'}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Estado actual:"
                        strong
                        fontSize="small"
                      />
                      <CustomText text={detailData?.status?.status} fontSize="middle" />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText text="Documento:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.document ? detailData?.document?.code + ' - ' + detailData?.document?.description : "Sin registrar"}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Observaciones:"
                        strong
                        fontSize="small"
                      />
                      <CustomText text={detailData?.observations} fontSize="middle" />
                    </div>
                  </Col>
                </Row>

                <GestorTableItems
                  detailData={detailData?.items}
                  columnsFijos={columTableFijos}
                  columnsBienes={columTableBienes}
                  goodsType={detailData?.goods_type}
                  isNotView
                />
              </Fragment>
            ),
          },
          {
            key: '2',
            label: (
              <Button type="link" icon={<FileSearchOutlined />}>
                Documentos
              </Button>
            ),
            children: (
              <>
                <CustomTable
                  dataSource={detailData?.documents?.map(
                    (doc: any, index: number) => ({
                      key: index,
                      createdAt: doc.created_at,
                      name: doc.url?.split('/').pop(),
                      link: doc.url,
                    })
                  )}
                  columns={documentColumns}
                  pagination={false}
                />
              </>
            ),
          },
          {
            key: '3',
            label: (
              <Button type="link" icon={<HistoryOutlined />}>
                Historial de la Solicitud
              </Button>
            ),
            children: (
              <CustomTable
                columns={[
                  {
                    title: 'Item',
                    dataIndex: 'index',
                    key: 'index',
                    render: (_: any, __: any, index: number) => index + 1,
                  },
                  {
                    title: 'Fecha',
                    dataIndex: 'date',
                    key: 'date',
                  },
                  {
                    title: 'Usuario',
                    dataIndex: 'user',
                    key: 'user',
                    render: (_: any, record: any) => record.document +  ' - ' + record.user,
                  },
                  {
                    title: 'Observaciones',
                    dataIndex: 'observations',
                    key: 'observations',
                  },
                  {
                    title: 'Estado',
                    dataIndex: 'comment',
                    key: 'comment',
                    render: (text: string) => {
                      if (!text) return '';
                      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
                    },
                  },
                ]}
                dataSource={
                  detailData?.history?.map((item: any, index: number) => ({
                    key: index,
                    date: item.date,
                    comment: item.comment,
                    user: item.user,
                    document: item.document,
                    observations: item.observations,
                  })) || []
                }
                pagination={false}
              />
            ),
          },
        ]}
      />
    </>
  );
};

export default GoodsDetailView;
